import type { ServerMessage } from '../../../types/api'

// Only for successful text /message responses; HTTP errors are handled by the caller.
// Voice HTTP 200 may mean failed recognition and requires a separate server contract.
export function isTextMessageAccepted(responses: readonly Pick<ServerMessage, 'metadata'>[]): boolean {
  return !responses.some(message => message.metadata?.action === 'show_pricing' || message.metadata?.action === 'show_limit_notice')
}
